<div class="row no-gutters justify-content-between mx-0">
  <fgbcl-notification-item
    class="px-0"
    [notification]="notification"
    [isNotificationToaster]="true"
    (removeNotification)="remove()"
  ></fgbcl-notification-item>
</div>
